import { html, LitElement, nothing } from 'lit';

class WishlistCount extends LitElement {
  static get properties() {
    return {
      count: { type: Number, state: true },
      link: { type: String, attribute: 'link' },
      width: { type: Number, attribute: 'width' },
      height: { type: Number, attribute: 'height' },
    };
  }

  constructor() {
    super();
    this.previousCount = 0;
  }

  createRenderRoot() {
    return this;
  }

  async connectedCallback() {
    super.connectedCallback();

    const wishlist = await window.wishlist.retrieve();
    this.count = wishlist.count;
    this.previousCount = wishlist.count;

    // Check for missed wishlist:initialise event
    window.eventKeeper?.onEventHeard('wishlist:initialise', (detail) => {
      this.updateCount(detail.count);
    });

    document.addEventListener('wishlist:initialise', (event) => {
      this.updateCount(event.detail.count);
    });

    document.addEventListener('wishlist:add', (event) => {
      this.updateCount(event.detail.count, true, false); // true indicates item was added
    });

    document.addEventListener('wishlist:remove', (event) => {
      this.updateCount(event.detail.count, false, true); // true indicates item was removed
    });

    document.addEventListener('wishlist:clear', (event) => {
      this.updateCount(event.detail.count);
    });

    document.addEventListener('wishlist:update', (event) => {
      this.updateCount(event.detail.count);
    });

    document.addEventListener('wishlist:move-product', (event) => {
      this.updateCount(event.detail.count);
    });
  }

  updateCount(newCount, itemAdded = false, itemRemoved = false) {
    this.previousCount = this.count;
    this.count = newCount;

    // Trigger pulse animation when count changes
    if (itemAdded && newCount > this.previousCount) {
      this.triggerHeartPulseAnimation('in');
    } else if (itemRemoved && newCount < this.previousCount) {
      this.triggerHeartPulseAnimation('out');
    }
  }

  triggerHeartPulseAnimation(type = 'in') {
    const button = this.querySelector('.wishlist_count_btn');

    if (button) {
      button.classList.remove('pulse_animation_in', 'pulse_animation_out');

      button.offsetHeight;

      const animationClass =
        type === 'in'
          ? 'pulse_animation_in'
          : 'pulse_animation_out';
      button.classList.add(animationClass);

      setTimeout(() => {
        button.classList.remove(animationClass);
      }, 300);
    }
  }

  render() {
    return html`
      <a href="${this.link}" title="${window.theme.strings.wishlist.title}" class="wishlist_count_btn header_icon_action" aria-label="${window.theme.strings.wishlist.wishlist_count.replace('{{ count }}', this.count)}">
        <svg width="${this.width || 24}" height="${this.height || 24}" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M11.9932 5.13581C9.9938 2.7984 6.65975 2.16964 4.15469 4.31001C1.64964 6.45038 1.29697 10.029 3.2642 12.5604C4.89982 14.6651 9.84977 19.1041 11.4721 20.5408C11.6536 20.7016 11.7444 20.7819 11.8502 20.8135C11.9426 20.8411 12.0437 20.8411 12.1361 20.8135C12.2419 20.7819 12.3327 20.7016 12.5142 20.5408C14.1365 19.1041 19.0865 14.6651 20.7221 12.5604C22.6893 10.029 22.3797 6.42787 19.8316 4.31001C17.2835 2.19216 13.9925 2.7984 11.9932 5.13581Z" fill="currentColor" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        ${this.count > 0
          ? html`<span class="wishlist_count">${this.count}</span>`
          : nothing}
      </a>
    `;
  }
}

window.customElements.get('wishlist-count') || window.customElements.define('wishlist-count', WishlistCount);
